

const { ccclass, property } = cc._decorator;

export interface IPokerFrameData{
    roomId?: number
    showLeaveBtn?: boolean
    showSettingBtn?: boolean
    showRuleBtn?: boolean
    showRoomInfo?: boolean
    showFreeRoomBtn?: boolean
    showIntrustBtn?: boolean
    showTime?: boolean

    clickLeaveBtnCallback?: Function
    clickFreeRoomBtnCallback?: Function
    clickIntrustBtnCallback?: Function
    clickSettingBtnCallback?: Function
    clickRuleBtnCallback?: Function
    clickRuleExplainBtnCallback?: Function
}

